import photo11 from "../../images/01.jpg";
import photo12 from "../../images/02.jpg";
import photo13 from "../../images/03.jpg";
import photo14 from "../../images/SeaPizza.jpg";
import photo15 from "../../images/SeaPasta.jpg";
import photo16 from "../../images/Mashroum.jpg";


const Data =[{
    image : photo11,
    Title :" Rainbow Vegetable Sandwich",
    text : "Time: 15 - 20 Minutes ",
    price : "$10.50",
    offer : "$11.70"
},
{
    image : photo12,
    Title :" Vegetarian Burger",
    text : "Time: 30 - 45 Minutes ",
    price : "$9.50",
    offer : "$10.70"
},
{
    image : photo13,
    Title :" Raspberry Stuffed French Toast",
    text : "Time: 35 - 40 Minutes",
    price : "$12.50",
    offer : "$13.70"
},
{
    image : photo14,
    Title :" Pizza with Seafood",
    text : "Time: 20 - 25 Minutes ",
    price : "$17.20",
    offer : "$19.80"
},
{
    image : photo15,
    Title :" Seafood Pasta",
    text : "Time: 10 - 15 Minutes",
    price : "$14.80",
    offer : "$16.75"
},
{
    image : photo16,
    Title :" Mashroom Risotto",
    text : "Time: 8 - 13 Minutes",
    price : "$12.50",
    offer : "$15.70"
}

]
export default Data ;